exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".box-content\r\n{\r\n    border: 1px solid #ddd;\r\n    padding: 20px; \r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/linegroup/linegroup.component.css
// module id = ../../../../../src/app/_components/linegroup/linegroup.component.css
// module chunks = main